import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PiWarningBold } from "react-icons/pi";
import { LuPen } from "react-icons/lu";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { wpsSetStep, setWpsOrderNumber } from "../../../store";
import AutoSave from "../../../components/forms/AutoSave";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Alert from "../../../components/Alert";

import { url } from "../../../configlink";

const Verification = ({ page, handleNextPage, handlePrevPage, progress }) => {
  const [isChecked, setIsChecked] = useState(false);
  const wpsState = useSelector((state) => state.wpsForm);
  const dispatch = useDispatch();

  // const token = localStorage.getItem("token");
  const user = useSelector((state)=> state.user.user)

  const acgtcards = useSelector((state) => state.acgtcard.cards)

  useEffect(() => {
    window.scrollTo(0,200)
  }, [])

  let loc = useLocation()

  let [checkBoxError, setCheckBoxError] = useState(false)

  let [buttonColor, setButtonColor] = useState(false)


  const reviewWarning = () => {
    return (
      <div className=' bg-[#FF991833] rounded-md flex items-center py-6 px-4 h-[72px] mt-4 mb-10'>
        <div>
          <PiWarningBold className='text-2xl text-[#713F00] m-3' />
        </div>
        <p className='font-semibold text-xl text-[#713F00]'>
          Please review the information below before submitting your order.
        </p>
      </div>
    );
  };

  function getDayOfWeek(dateString) {
    const [year, month, day] = dateString.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const dayOfWeek = date.getDay();
  
    return daysOfWeek[dayOfWeek];
  }

  const reviewNote = () => {
    return (
      <div className=' bg-[#0091EA] bg-opacity-15 rounded-md flex flex-col py-6 px-4 mt-4 mb-10'>
        <div className='flex items-center'>
          <IoMdInformationCircleOutline className='text-2xl text-[#076DAC] m-3' />
          <p className='font-bold text-xl text-[#076DAC]'>Important Note</p>
        </div>
        <p className='font-semibold text-md text-[#076DAC] ml-12'>
          Your order includes Map to Reference Data analysis, which requires
          reference sequences. Please email FASTA format sequences to{" "}
          <u>ngs@acgtinc.com</u> with Order Number and Sample ID clearly
          identified.{" "}
          <b>Order cannot start without reference sequences received.</b>
        </p>
      </div>
    );
  };

  //Variables for Table Data
  const samplePropertiesToShow = [
    "id",
    "sampleID",
	"sampleType",
	"sampleConc",
    "targetSize",
    // "dataAnalysis",
  ];

  const primerPropertiesToShow = ["id", "pName", "pSequence"];

  const renderedPrimerRows = [
    ...wpsState.primer.primerSynthesisList.map((item, index) => (
      <tr key={item.id}>
        {primerPropertiesToShow.map((property) => (
          <td key={property} className='p-0'>
            {property === "pName" ? (
              <div className=' h-10 py-2 px-4 border-[1px] border-gray-300 w-full'>
                {item[property]}
              </div>
            ) : property === "pSequence" ? (
              <div className=' h-10 py-2 px-4 border-[1px] border-gray-300 w-full'>
                {item[property]}
              </div>
            ) : property === "id" ? (
              <div className=' text-center font-bold h-10 py-2 px-4 border-[1px] border-gray-300 w-full'>
                {item[property]}
              </div>
            ) : null}
          </td>
        ))}
      </tr>
    )),
  ];

  const renderedSampleRows = [
    ...wpsState.data.tableData.map((item) => (
      <tr key={item.id}>
        {samplePropertiesToShow.map((property) => (
          <td key={property} className='p-0'>
            {property === "sampleID" ? (
              <div className=' h-10 py-2 px-4 border-[1px] border-gray-300 w-full'>
                {item[property]}
              </div>
            )
            : property === "sampleConc" ? (
              <div className=' h-10 py-2 px-4 border-[1px] border-gray-300 w-full'>
				{item[property] === 0 ? '-' : item[property] }
              </div>
            )
            : property === "sampleType" ? (
              <div className=' h-10 py-2 px-4 border-[1px] border-gray-300 w-full'>
                {item[property].label}
              </div>
            ) : property === "targetSize" ? (
              <div className=' h-10 py-2 px-4 border-[1px] border-gray-300 w-full'>
                {item[property]}
              </div>
            ) 
            : property === "dataAnalysis" ? (
              <div className=' h-10 py-2 px-4 border-[1px] border-gray-300 w-full'>
                {item[property].label}
              </div>
            ) 
            : property === "id" ? (
              <div className=' text-center font-bold h-10 py-2 px-4 border-[1px] border-gray-300 w-full'>
                {item[property]}
              </div>
            ) : null}
          </td>
        ))}
      </tr>
    )),
  ];


  // console.log(wpsState);

  let navigate = useNavigate()

  function completeOrder() {
    
    // handleNextPage()
    if(isChecked===true) {
      // console.log(wpsState);
      
      // alert("For now, this is a demo. Please click on cancel button")
      let data = {
        UserId: user.UserId,
        data: wpsState.data,
        billingInfo: wpsState.billingInformation 
      }

      setButtonColor(true)

      //delete draft
      if(loc.search.includes('draftId')){
        let orderNum = loc.search.split('=')[1]
        // console.log(orderNum);
        
        try {
          fetch(`${url}/api/orderForm/deleteOrderDraft?orderId=${orderNum}`, {
            method: "DELETE",
            credentials: 'include',
            // headers: {
            //   Authorization: `Bearer ${token}`,
            // },
          })
            .then((res) => res.json())
            .then((data) => {
              // console.log(data);
            })
            .catch((err) => {
              console.error(err);
            });
        } catch (err) {
          console.error(err);
        }
      }
  
      //insert
      try{
        fetch(`${url}/api/orderForm/createWpsUserOrder`, {
          method: "POST",
          credentials: 'include',
          headers: {
            // Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((data) => {
            // console.log(data);
            if(data.message === 'Success'){
              dispatch(setWpsOrderNumber(parseInt(data.orderId)+600000))
              handleNextPage()
              navigate('/orders/wps')
              setButtonColor(false)
            }
          })
          .catch((err) => {
            setButtonColor(false)
            console.error(err);
          });
        }
        catch(err){
        setButtonColor(false)
        console.error("POST error: ",err);
      }
    }
    else{
      window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
      setCheckBoxError(true)
      // scroll to bottom 
    }
    
    
  }

  let [draftSuccess,setDraftSuccess] = useState(false)

  const passMessage = (message) => {
    // console.log("message");
    
    if(message === 'success'){
      window.scrollTo({top:200, left:0, behavior:'smooth'})
      setDraftSuccess(true)
      setTimeout(() => {
        setDraftSuccess(false)
      }, 5000)
    }
    else if(message === 'failure'){
      alert("Something went wrong..")
    }
  }


  return (
    <>
      <div className='px-8 xl:px-16'>
        <h1 className='text-3xl xl:text-4xl text-[var(--color-primary-purple)] font-black my-[40px]'>
          {/* Wps High-Throughput Sequencing */}
          Whole Plasmid Sequencing
        </h1>
        {draftSuccess && 
          <div className="mb-3">
            <Alert type="success">
              <span className="whitespace-nowrap">Form successfully saved to drafts. You can find your saved drafts by going to <Link to="/orderhistory" className="underline">My Orders.</Link></span>
            </Alert>
          </div>
          }
        <div className="w-full overflow-hidden">
          {progress}
          </div>
        {reviewWarning()}
        {/* {reviewNote()} */}
        <div className=' mb-14'>
          <div>
            {/* <div className='flex my-5'>
                <p className=' w-[300px] text-lg text-[var(--color-primary-purple)] font-black'>
                  Service Option
                </p>
                <p className='text-lg text-[background: #1F1F1F] font-bold'>
                  {wpsState.data.serviceOption.value === 2? 'Premium Service': 'Standard Service'}
                </p>
              </div> */}
            <div className='flex justify-between'>
              <div className='border-b-[1px] border-[var(--color-primary-purple)] w-11/12'>
                <p className='text-2xl text-[var(--color-primary-purple)] font-bold '>
                  Sample Information
                </p>
              </div>
              <button
                onClick={() => dispatch(wpsSetStep(0))}
                className='border-2 border-[#302a7e] px-6 py-4 rounded-3xl font-bold gap-2 text-[var(--color-primary-purple)] bg-white uppercase w-[116px] h-[48px] flex items-center ml-10'
              >
                <LuPen />
                <p>edit</p>
              </button>
            </div>
          </div>
          <div className='mt-4'>
            <table className='border-1 border-black w-full'>
              <thead>
                <tr className='bg-gray-200 h-16'>
                  <th className=' font-bold border-[1px] border-gray-300 text-center'>
                    #
                  </th>
                  <th className=' font-bold border-[1px] text-center border-gray-300 xl:min-w-[410px]'>
                    Sample ID
                  </th>
					<th className=' font-bold border-[1px] border-gray-300 text-center xl:min-w-[250px]'>
						Sample Type
					</th>
					<th className=' font-bold border-[1px] border-gray-300 text-center xl:min-w-[150px]'>
						Sample Conc. (ng/ul)
					</th>
					
                  <th className=' font-bold border-[1px] border-gray-300 text-center xl:min-w-[250px]'>
                    Est. Target Size (kb)
                  </th>
                  {/* <th className=' font-bold border-[1px] text-center border-gray-300 xl:min-w-[221px]'>
                    Data Analysis
                  </th> */}
                </tr>
              </thead>
              <tbody>{renderedSampleRows}</tbody>
            </table>
          </div>
        </div>

        <div className='flex justify-between mb-14'>
          <div className=' w-[48%]'>
            <div className='flex justify-between'>
              <div className='border-b-[1px] border-[var(--color-primary-purple)] w-11/12'>
                <p className='text-2xl text-[var(--color-primary-purple)] font-bold '>
                  Customer Information
                </p>
              </div>
              <button
                onClick={() => dispatch(wpsSetStep(2))}
                className='border-2 border-[#302a7e] px-6 py-4 rounded-3xl font-bold gap-2 text-[var(--color-primary-purple)] bg-white uppercase w-[116px] h-[48px] flex items-center ml-10'
              >
                <LuPen />
                <p>edit</p>
              </button>
            </div>
            <div>
              <div className='flex my-5'>
                <p className=' w-1/3 text-lg text-[var(--color-primary-purple)] font-black'>
                  Name
                </p>
                <p className='w-2/3 text-lg text-[background: #1F1F1F] font-bold'>
                  {wpsState.billingInformation.firstName}{" "}
                  {wpsState.billingInformation.lastName}
                </p>
              </div>
              <div className='flex my-5'>
                <p className=' w-1/3 text-lg text-[var(--color-primary-purple)] font-black'>
                  Company
                </p>
                <p className='w-1/3 text-lg text-[background: #1F1F1F] font-bold'>
                  {wpsState.billingInformation.company}
                </p>
              </div>
              <div className='flex my-5'>
                <p className=' w-1/3 text-lg text-[var(--color-primary-purple)] font-black'>
                  Phone
                </p>
                <p className='w-1/3 text-lg text-[background: #1F1F1F] font-bold'>
                  {wpsState.billingInformation.phone}
                </p>
              </div>
              <div className='flex my-5'>
                <p className=' w-1/3 text-lg text-[var(--color-primary-purple)] font-black'>
                  Email
                </p>
                <p className='w-1/3 text-lg text-[background: #1F1F1F] font-bold'>
                  {wpsState.billingInformation.email}
                </p>
              </div>
            </div>
          </div>
          <div className=' w-[48%]'>
            <div className='flex justify-between'>
              <div className='border-b-[1px] border-[var(--color-primary-purple)] w-11/12'>
                <p className='text-2xl text-[var(--color-primary-purple)] font-bold '>
                  Billing Information
                </p>
              </div>
              <button
                onClick={() => dispatch(wpsSetStep(2))}
                className='border-2 border-[#302a7e] px-6 py-4 rounded-3xl font-bold gap-2 text-[var(--color-primary-purple)] bg-white uppercase w-[116px] h-[48px] flex items-center ml-10'
              >
                <LuPen />
                <p>edit</p>
              </button>
            </div>
            <div className='flex'>
              <div className=' my-5 w-1/3'>
                <p className=' text-lg text-[var(--color-primary-purple)] font-black'>
                  Billing Information
                </p>
              </div>
              {wpsState.billingInformation.billingMethod === "P.O. Number" && (
                <div className='flex justify-between w-10/12'>
                  <div className='flex flex-col w-2/3'>
                    <div className='flex justify-between items-start my-5'>
                      <p className='text-lg text-gray-500 font-bold '>
                        Payment Type
                      </p>
                      <p className='text-lg font-bold  w-2/5'>
                        {wpsState.billingInformation.billingMethod}
                      </p>
                    </div>
                    <div className='flex justify-between my-5'>
                      <p className='text-lg text-gray-500 font-bold '>
                        P.O. Number
                      </p>
                      <p className='text-lg font-bold  w-2/5'>
                        {wpsState.billingInformation.poNumber}
                      </p>
                    </div>
                    <div className='flex justify-between my-5'>
                      <p className='text-lg text-gray-500 font-bold '>
                        Purchasing Agent Name
                      </p>
                      <p className='text-lg font-bold w-2/5'>
                        {wpsState.billingInformation.purchasingAgentName}
                      </p>
                    </div>
                    <div className='flex justify-between my-5'>
                      <p className='text-lg text-gray-500 font-bold '>
                        Purchasing Agent Email
                      </p>
                      <p className='text-lg font-bold w-2/5'>
                        {wpsState.billingInformation.purchasingAgentEmail}
                      </p>
                    </div>
                  </div>
                </div>
              )}
              {wpsState.billingInformation.billingMethod === "Credit Card" && (
                <div className='flex justify-between w-10/12'>
                  <div className='flex flex-col w-2/3'>
                    <div className='flex justify-between items-start my-5'>
                      <p className='text-lg text-gray-500 font-bold '>
                        Payment Type
                      </p>
                      <p className='text-lg font-bold  w-2/5'>
                        {wpsState.billingInformation.billingMethod}
                      </p>
                    </div>
                    <div className='flex justify-between my-5'>
                      <p className='text-lg text-gray-500 font-bold '>
                        Card Type
                      </p>
                      <p className='text-lg font-bold  w-2/5'>
                        {wpsState.billingInformation.cardType}
                      </p>
                    </div>
                    <div className='flex justify-between my-5'>
                      <p className='text-lg text-gray-500 font-bold '>
                        Expiration Date
                      </p>
                      <p className='text-lg font-bold w-2/5'>
                        {wpsState.billingInformation.ccMonth}/
                        {wpsState.billingInformation.ccYear}
                      </p>
                    </div>
                    <div className='flex justify-between my-5'>
                      <p className='text-lg text-gray-500 font-bold '>
                        Card Number
                      </p>
                      <p className='text-lg font-bold w-2/5'>
                        {wpsState.billingInformation.ccNumber}
                      </p>
                    </div>
                  </div>
                </div>
              )}
              {wpsState.billingInformation.billingMethod === "ACGT Card" && (
                <div className='flex justify-between w-10/12'>
                  <div className='flex flex-col w-2/3'>
                    <div className='flex justify-between items-start my-5'>
                      <p className='text-lg text-gray-500 font-bold my-2  w-2/5'>
                        Payment Type
                      </p>
                      <p className='text-lg font-bold my-2 w-2/5'>
                        {wpsState.billingInformation.billingMethod}
                      </p>
                    </div>
                    <div className='flex justify-between my-5'>
                      <p className='text-lg text-gray-500 font-bold my-2  w-2/5'>
                        Card Number
                      </p>
                      <p className='text-lg font-bold my-2  w-2/5'>
                        {acgtcards.filter(item => item.id === parseInt(wpsState.billingInformation.acgtCard))[0].cardnumber}
                      </p>
                    </div>
                  </div>
                </div>
              )}
              {wpsState.billingInformation.billingMethod ===
                "Purchasing Agent" && (
                  <div className='flex justify-between w-10/12'>
                  <div className='flex flex-col w-2/3'>
                  <div className='flex justify-between items-start my-5'>
                      <p className='text-lg text-gray-500 font-bold '>
                        Payment Type
                      </p>
                      <p className='text-lg font-bold'>
                        {wpsState.billingInformation.billingMethod}
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {wpsState.billingInformation.billingMethod === "Grant" && (
                <div className='flex justify-between w-10/12'>
                  <div className='flex flex-col w-2/3'>
                    <div className='flex justify-between items-start my-5'>
                      <p className='text-lg text-gray-500 font-bold '>
                        Payment Type
                      </p>
                      <p className='text-lg font-bold  w-2/5'>
                        {wpsState.billingInformation.billingMethod}
                      </p>
                    </div>
                    <div className='flex justify-between my-5'>
                      <p className='text-lg text-gray-500 font-bold '>
                        Grant Number
                      </p>
                      <p className='text-lg font-bold  w-2/5'>
                        {wpsState.billingInformation.grantNumber}
                      </p>
                    </div>
                    <div className='flex justify-between my-5'>
                      <p className='text-lg text-gray-500 font-bold '>
                        Grant PI
                      </p>
                      <p className='text-lg font-bold w-2/5'>
                        {wpsState.billingInformation.grantPi}
                      </p>
                    </div>
                    <div className='flex justify-between my-5'>
                      <p className='text-lg text-gray-500 font-bold '>
                       Grant Note
                      </p>
                      <p className='text-lg font-bold w-2/5'>
                        {wpsState.billingInformation.grantNote}
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className='flex justify-between mb-14'>
          <div className=' w-[48%]'>
            <div className='flex justify-between'>
              <div className='border-b-[1px] border-[var(--color-primary-purple)] w-11/12'>
                <p className='text-2xl text-[var(--color-primary-purple)] font-bold '>
                  Sample Shipping
                </p>
              </div>
              <button
                onClick={() => dispatch(wpsSetStep(2))}
                className='border-2 border-[#302a7e] px-6 py-4 rounded-3xl font-bold gap-2 text-[var(--color-primary-purple)] bg-white uppercase w-[116px] h-[48px] flex items-center ml-10'
              >
                <LuPen />
                <p>edit</p>
              </button>
            </div>
            <div>
              <div className='flex my-5'>
                <p className=' w-1/3 text-lg text-[var(--color-primary-purple)] font-black'>
                  Delivery Type
                </p>
                <p className='w-2/3 text-lg text-[background: #1F1F1F] font-bold'>
                  {wpsState.billingInformation.shippingOption}
                </p>
              </div>
              {wpsState.billingInformation.shippingOption === 'Dropbox' && 
              <>
                <div className='flex my-5'>
                  <p className=' w-1/3 text-lg text-[var(--color-primary-purple)] font-black'>
                    Location
                  </p>
                  <p className='w-1/3 text-lg text-[background: #1F1F1F] font-bold'>
                    {wpsState.billingInformation.dropboxLocation}
                  </p>
                </div>
                <div className='flex my-5'>
                  <p className=' w-1/3 text-lg text-[var(--color-primary-purple)] font-black'>
                    Drop-off Date
                  </p>
                  <p className='w-1/3 text-lg text-[background: #1F1F1F] font-bold'>
                  {getDayOfWeek(wpsState.billingInformation.dropoffDate)}, {wpsState.billingInformation.dropoffDate.split('-')[1]}/{wpsState.billingInformation.dropoffDate.split('-')[2]}/{wpsState.billingInformation.dropoffDate.split('-')[0]}
                  </p>
                </div>
              </>
              }
            </div>
          </div>
          <div className=' w-[48%]'>
            <div className='flex justify-between'>
              <div className='border-b-[1px] border-[var(--color-primary-purple)] w-11/12'>
                <p className='text-2xl text-[var(--color-primary-purple)] font-bold '>
                  Additional Comments
                </p>
              </div>
              <button
                onClick={() => dispatch(wpsSetStep(1))}
                className='border-2 border-[#302a7e] px-6 py-4 rounded-3xl font-bold gap-2 text-[var(--color-primary-purple)] bg-white uppercase w-[116px] h-[48px] flex items-center ml-10'
              >
                <LuPen />
                <p>edit</p>
              </button>
            </div>
            <div className='border-2 border-gray-500 bg-gray-100 mt-4 min-h-20'>
              <div className='p-4'>
                {wpsState.data.comments.length < 0
                  ? ""
                  : wpsState.data.comments}
              </div>
            </div>
          </div>
        </div>

        <div className='flex flex-col items-center'>
          <div className='flex justify-center items-start'>
            <input
              type='checkbox'
              id='myCheckbox'
              checked={isChecked}
              onChange={() => {
                setCheckBoxError(false)
                setIsChecked(!isChecked)}
              } 
              className='hidden'
            />
            <label
              htmlFor='myCheckbox'
              className='cursor-pointer flex items-start'
            >
              {isChecked ? (
                <div className=' text-2xl text-[var(--color-primary-purple)] mt-1'>
                  <MdCheckBox />
                </div>
              ) : (
                <div className=' text-2xl text-[var(--color-primary-purple)] mt-1'>
                  <MdCheckBoxOutlineBlank />
                </div>
              )}
            </label>

            <span className='ml-4 text-[#1F1F1F] font-bold text-lg'>
            I have reviewed the information above and <br/>confirm it is accurate, valid and complete.
            </span>
          </div>
          {checkBoxError && <span className="text-[14px] text-red-500 font-bold">Please check the box</span>}
        </div>
      </div>
      <AutoSave
        currentOrderForm={wpsState}
        page={page}
        handleNextPage={completeOrder}
        handlePrevPage={handlePrevPage}
        steps={5}
        passMessage={passMessage}
        buttonColor={buttonColor}
      />
    </>
  );
};

export default Verification;
